<template>
  <div>
    <b-card>
      <b-card-title>RECIBO</b-card-title>
      <b-card-text>
        <b-row>
          <b-col>
            Recebemos de {{ bill_data.bill.person.name }}
            <span v-if="!isJuridic"
              >portador do CPF: {{ person_document | cpf }}
            </span>
            <span v-if="isJuridic">
              portador do CNPJ: {{ person_document | cnpj }} </span
            >, a importância de
            {{ bill_data.bill.payed_value | moneyBr }}
            ({{ bill_data.bill.payed_value | decimal | extenso }})
            correspondente ao pagamento parcial do documento/parcela Nº
            {{ bill_data.bill.document }}, pago com
            {{ paymentMethods[bill_data.payment_method].text }}.

            <template v-if="hasOrder">
              <br />
              referente a:
              <br />
              <table class="table table-sm col-12">
                <thead>
                  <tr>
                    <th>Produto</th>
                    <th>Qt</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in bill_data.products" :key="index">
                    <td class="col-11">{{ row.product }}</td>
                    <td class="col-1">{{ row.quantity }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </b-col>
        </b-row>
        <br />

        <b-row>
          <b-col>
            {{ company.address.city }} -
            {{ bill_data.bill.payed_at | dateBr }}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col
            >{{ company.name }} <br />
            CNPJ: {{ company.cnpj | cnpj }}</b-col
          >
        </b-row>
        <b-row>
          <b-col>
            {{ company.address.address }}, {{ company.address.number }}
            {{ company.address.district }} - {{ company.address.city }}-{{
              company.address.state
            }}
            <br />
            - CEP:
            {{ company.address.zipcode | cep }}
            <span v-if="company.address.complement"
              >,{{ company.address.complement }}</span
            >
          </b-col>
          <br />
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    bill_data: {
      type: Object,
    },
  },
  data() {
    return {
      paymentMethods: {
        1: {
          text: "Dinheiro",
        },

        2: {
          text: "Cheque",
        },

        3: {
          text: "Cartão de Credito",
        },
        4: {
          text: "Cartão de Débito",
        },
        5: {
          text: "Crediário",
        },

        15: {
          text: "Boleto Bancário",
        },
        16:{
          text:"Depósito Bancário"
        },
        17: {
          text: "Pix",
        },
        18: {
          text: "Carteira Digital ",
        },

        99: {
          text: "Outros",
        },
      },
    };
  },
  computed: {
    company() {
      return this.$store.state.company;
    },
    hasOrder() {
      return this.bill_data.bill.order_id != null;
    },

    isJuridic() {
      return this.bill_data.bill.person.person_type == "j";
    },

    person_document() {
      if (this.isJuridic) {
        return this.bill_data.bill.person.cnpj
          ? this.bill_data.bill.person.cnpj
          : "";
      }
      if (!this.isJuridic) {
        return this.bill_data.bill.person.cpf
          ? this.bill_data.bill.person.cpf
          : "";
      }
    },
  },
};
</script>

<style scoped>
.card {
  width: 80mm;
}
h4.card-title {
  text-align: center;
}
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 8pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  padding: 0.5cm;
  margin: 0.5cm;
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .card {
    width: 40%;
    height: 100%;
    border: none;
    font-weight: 900;
    text-align: justify;
    font-family: "Arial", sans-serif;
  }
  .card-title {
    font-weight: 900;
  }

  .not-print {
    display: none;
  }
}
</style>
